export const traducciones = {
  1: {
    es: {
      id: 1,
      titlePortfolio: "Portafolio",
      title: "¿Quiénes somos?",
      description: "En QAntico Devs, nos dedicamos al desarrollo de software a la medida y a la creación de soluciones propias diseñadas para responder a necesidades reales del mercado.",
      description2: "Nuestro enfoque se centra en construir herramientas tecnológicas eficientes, escalables y funcionales que aporten valor desde el primer uso.",
      description3: "Trabajamos directamente con cada cliente para entender a fondo sus requerimientos, procesos y objetivos.",
      description4: "A partir de eso, diseñamos soluciones específicas que se ajustan perfectamente a sus necesidades operativas y estratégicas. No ofrecemos productos genéricos ni soluciones enlatadas: cada desarrollo es único y orientado a resultados. Además, estamos en constante evolución creando y perfeccionando productos propios que estarán disponibles para su comercialización, enfocados en optimizar la gestión empresarial, la productividad y la experiencia digital.",
      textTecnology: "Nos mueve la tecnología, pero sobre todo, el impacto que puede generar cuando se aplica de forma inteligente.",
      tecnology: "React, HTML, CSS, JavaScript",
      imageUrl: "img/about/profileAbout.svg",
      imageUrl2: "img/about/profileAbout2.svg",
      textUrl: "Contáctanos",
      url: "/contact",
    },
    en: {
      id: 1,
      titlePortfolio: "Portfolio",
      title: "About us",
      description: "At QAntico Devs, we focus on developing tailored software and creating our own solutions designed to meet real market needs.",
      description2: "Our focus is on building efficient, scalable, and functional technological tools that add value from the first use.",
      description3: "We work directly with each client to thoroughly understand their requirements, processes, and objectives.",
      description4: "From there, we design specific solutions that perfectly fit their operational and strategic needs. We do not offer generic products or canned solutions: each development is unique and results-oriented. Additionally, we are constantly evolving, creating and refining our own products that will be available for commercialization, focused on optimizing business management, productivity, and digital experience.",
      textTecnology: "We move technology, but above all, the impact that can be generated when applied intelligently.",
      tecnology: "React, HTML, CSS, JavaScript",
      imageUrl: "img/about/profileAbout.svg",
      imageUrl2: "img/about/profileAbout2.svg",
      textUrl: "Contact us",
      url: "/contact",
    }
  }
  
  
};